import { Component, Inject, Input } from '@angular/core';
import { Preferences } from '@vendasta/meetings';
import {
  INTEGRATIONS_PAGE_LINK_TOKEN,
  MEETING_INTEGRATION_SERVICE_KEYS_TOKEN,
  PERSONAL_CALENDAR_ID_TOKEN,
  RECOMMENDED_PERSONAL_CALENDAR_SLUGS_TOKEN,
} from '../../data-providers/providers';
import { Observable } from 'rxjs';
import { MeetingIntegrationServiceKeys } from '../../interface';

@Component({
  selector: 'meeting-scheduler-settings',
  templateUrl: './schedule-settings.component.html',
  styleUrls: ['./schedule-settings.component.scss'],
  standalone: false,
})
export class ScheduleSettingsComponent {
  @Input() isHostConfigured: boolean;
  @Input() isGoogleMeetConfigured: boolean;
  @Input() isMicrosoftConfigured: boolean;
  @Input() hostPreferences: Preferences;
  enableTracking = true;
  
  selectedCalendarProvider: string;

  constructor(
    @Inject(MEETING_INTEGRATION_SERVICE_KEYS_TOKEN) public readonly SERVICE_KEYS: MeetingIntegrationServiceKeys,
    @Inject(INTEGRATIONS_PAGE_LINK_TOKEN) public readonly integrationsPageLink$: Observable<string>,
    @Inject(RECOMMENDED_PERSONAL_CALENDAR_SLUGS_TOKEN) public readonly recommendedSlugs$: Observable<string[]>,
    @Inject(PERSONAL_CALENDAR_ID_TOKEN) public readonly personalCalendarId$: Observable<string>,
  ) {}

  handleCalendarProvider(provider: string) {
    this.selectedCalendarProvider = provider;
  }
}
